import { motion } from "framer-motion";
import { Phone, MessageSquareText, Mail } from "lucide-react";
import { BRAND } from "@/data/site";

const ACTIONS = [
  { href: `tel:${BRAND.phoneRaw}`, icon: Phone, label: "Call", testid: "fab-call" },
  { href: `sms:${BRAND.phoneRaw}`, icon: MessageSquareText, label: "Text", testid: "fab-text" },
  { href: `mailto:${BRAND.email}`, icon: Mail, label: "Email", testid: "fab-email" },
];

export default function FloatingHub() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.6, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-1 bg-[#0b1838]/90 backdrop-blur-xl border border-cyan-400/40 rounded-full p-1.5 animate-pulse-glow"
      data-testid="floating-action-hub"
    >
      {ACTIONS.map(({ href, icon: Icon, label, testid }) => (
        <a
          key={label}
          href={href}
          data-testid={testid}
          aria-label={label}
          className="group flex items-center gap-2 px-4 py-3 rounded-full text-slate-300 hover:bg-cyan-400 hover:text-[#030712] transition-colors"
        >
          <Icon className="w-5 h-5" />
          <span className="hidden sm:inline text-xs font-bold uppercase tracking-widest">{label}</span>
        </a>
      ))}
    </motion.div>
  );
}
